import { persist } from "zustand/middleware";
import { OrderType } from "../types/enums";
import { create } from "zustand";

interface SavedLocation {
  city: string;
  area?: string;
  branch?: string;
  orderType?: OrderType;
}

interface NavOptions {
  title?: string;
}

interface AppState {
  location?: SavedLocation;
  navOptions: Record<string, NavOptions>;
  setLocation: (location?: SavedLocation) => void;
  setNavOptions: (path: string, options: NavOptions) => void;
}

const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      location: undefined,
      navOptions: {},
      setLocation: (location) => set({ location }),
      setNavOptions: (path, options) =>
        set((state) => ({
          navOptions: {
            ...state.navOptions,
            [path]: { ...state.navOptions[path], ...options },
          },
        })),
    }),
    {
      name: "app",
      partialize: (state) => ({ location: state.location }),
    },
  ),
);

export default useAppStore;
